import React, { useState, useEffect, useMemo } from 'react';
import cn from 'classnames';

const GettingStartedFamilyPet = ({ invalid, onChange }) => {
  const [pet, setPet] = useState({ type: undefined, name: undefined });
  const isDirty = useMemo(() => !!pet.type || !pet.name, [pet]);
  useEffect(
    () => {
      onChange(pet);
    },
    [pet],
  );
  return (
    <div
      className={cn('member-selection_row -border', {
        'has-error -error-position-bottom': invalid && !pet.type,
      })}
    >
      <label
        className="member-selection_checkbox"
        onClick={e => {
          e.preventDefault();
          setPet({ ...pet, type: 'dog' });
        }}
      >
        <input
          className="member-selection_checkbox-input"
          type="radio"
          readOnly
          value="dog"
          checked={pet.type === 'dog'}
        />
        <span className="member-selection_checkbox-label -mint -highlight-mint">Dog</span>
      </label>

      <label
        className="member-selection_checkbox"
        onClick={e => {
          e.preventDefault();
          setPet({ ...pet, type: 'cat' });
        }}
      >
        <input
          className="member-selection_checkbox-input"
          type="radio"
          readOnly
          value="cat"
          checked={pet.type === 'cat'}
        />
        <span className="member-selection_checkbox-label -mint -highlight-mint">Cat</span>
      </label>

      <label
        className="member-selection_checkbox"
        onClick={e => {
          e.preventDefault();
          setPet({ ...pet, type: 'other' });
        }}
      >
        <input
          className="member-selection_checkbox-input"
          type="radio"
          readOnly
          value="other"
          checked={pet.type === 'other'}
        />
        <span className="member-selection_checkbox-label -mint -highlight-mint">Other</span>
      </label>

      {pet.type === 'other' && (
        <div
          className={cn('form-group member-selection_input real-value', {
            'has-error -error-position-bottom': isDirty && !pet.name,
          })}
        >
          <input
            className="form-control"
            placeholder="Pet"
            onBlur={e => {
              e.preventDefault();
              setPet({ ...pet, name: e.target.value });
            }}
          />
        </div>
      )}
    </div>
  );
};

export default GettingStartedFamilyPet;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedFamily/GettingStartedFamilyPet.js